// extracted by mini-css-extract-plugin
export default {"text":"coFbIg","mobile":"dFEv2E"};